<template>
  <div class="agent-report-panel">
    <div class="report-icon-container">
      <div class="report-icon-bg">
        <i :class="['far', report.icon]" />
      </div>
    </div>
    <div class="report-info-container">
      <div class="title">{{report.name}}</div>
      <div class="description">{{report.details || report.description}}</div>

      <div class="link mt-2">
        <FormButton @click="$emit('startReport')" class="btn-sm btn-default"><i class="fas fa-play" /> Start Report</FormButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.agent-report-panel {
  background: #EBE8E4;
  padding: 8px;
  border-radius: $layout-minor-border-radius;
  border: 1px solid #e0e0e0;
  color: #424141;
  cursor: pointer;

  display: flex;
  flex-direction: row;
}
.report-icon-container {
  width: 50px;
}
.report-info-container {
  flex: 1;
  text-align: left;
}
.report-info-container .title {
  font-size: 15px;
  font-weight: bold;
}
.report-info-container .description {
  font-size: 11px;
  color: #888888;
}
.report-icon-bg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #424141;
  color: #d3cebc;
  text-align: center;
  line-height: 42px;
  vertical-align: middle;
  font-size: 20px;
}
</style>

<script>
export default {
  name: 'AIReportPanel',
  props: {
    agent: Object,
    report: Object,
    selected: Boolean
  },
}
</script>